export { default as Layout } from 'secured/components/SecuredLayout';



// WEBPACK FOOTER //
// src/modules/secured/components/index.js